import React, { useCallback, useEffect, useState } from 'react';
import DriverLinks from './DriverLinks';
import DriverRoster from './DriverRoster';
import MessagingSetup from './MessagingSetup';
import StoreContacts from './StoreContacts';
import VehiclePositions from './VehiclePositions';
import { api } from '../services/api';
import ErpAccess from './ErpAccess';
import Measurements from './Measurements';
import PlanningSettings from './PlanningSettings';
import { Driver } from '../types';

/**
 * Podešavanja: ono što se namesti jednom i ne dira se svaki dan.
 *
 * Postoji zato što je „Sa terena" počeo da nosi devet odeljaka — hitne
 * izuzetke i sparivanje GPS uređaja u istom pogledu. Operater ujutru gleda
 * šta gori, a linkove i zamenike namešta kad se nešto promeni; to dvoje ne
 * treba da se takmiče za isti prostor.
 */
export default function Settings() {
  const [drivers, setDrivers] = useState<Driver[]>([]);

  // Pad poziva se hvata da ekran ostane živ, ali se IMENUJE. Prazan spisak
  // vozača inače izgleda isto kao „nema ni jednog vozača u šifarniku" — a to bi
  // operatera poslalo da traži grešku u šifarniku umesto u vezi sa serverom.
  const [spisakNijeStigao, setSpisakNijeStigao] = useState(false);

  const load = useCallback(async () => {
    try {
      setDrivers(await api.drivers());
      setSpisakNijeStigao(false);
    } catch {
      setDrivers([]);
      setSpisakNijeStigao(true);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return (
    <div className="settings">
      <p className="note">
        Ovo se namešta kad se nešto promeni — nov vozač, poslovođa na
        godišnjem, zamena GPS uređaja. Posao dana je na kartici „Sa terena".
      </p>

      {spisakNijeStigao && (
        <div className="health health--bad">
          Spisak vozača nije stigao sa servera. Prazno <strong>ne znači</strong> da
          vozača nema — znači da se nije moglo pročitati. Osveži stranicu.
        </div>
      )}

      <PlanningSettings />

      <DriverRoster />

      {drivers.length > 0 && <DriverLinks drivers={drivers} onChanged={() => void load()} />}

      <StoreContacts />

      <VehiclePositions mode="setup" />

      <MessagingSetup />

      <Measurements />

      <ErpAccess />
    </div>
  );
}
